var map = {
	"./Chairlift.png": "2r98",
	"./Detachable Chairlift.png": "v6lO",
	"./Gondola.png": "uPqX",
	"./Lift.png": "Aemi",
	"./Magic Carpet.png": "j9Ez",
	"./carpet.png": "renc",
	"./chair_lift.png": "NXvE",
	"./easier.png": "hFrp",
	"./event.png": "0oaX",
	"./extremely_difficult.png": "BSrf",
	"./grooming.png": "td6P",
	"./grooming_false.png": "34/A",
	"./grooming_race.png": "hwoT",
	"./grooming_true.png": "Ldvs",
	"./more_difficult.png": "fu0C",
	"./most_difficult.png": "W+7E",
	"./opening_closed.png": "ffoS",
	"./opening_event.png": "iVSQ",
	"./opening_on_hold.png": "Rtm/",
	"./opening_open.png": "caZU",
	"./opening_scheduled.png": "S/x7",
	"./race.png": "z8Ha",
	"./snowmaking_24h.png": "Fj31",
	"./snowmaking_false.png": "WwuV",
	"./snowmaking_true.png": "5Buh",
	"./track_lift_cable_car.png": "3INx",
	"./track_trail_gladed.png": "eX+G",
	"./track_trail_with_snowmaking.png": "lZR6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "V5bU";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*\.png$
// module id = V5bU
// module chunks = 1